const accountId = {
	account: {
		title: "Akun",
		subtitle: "Kelola paket, info partner, rekening, dan pengaturan",
		loading: "Memuat…",
		tabs: {
			billing: "Tagihan",
			partner: "Info Partner",
			bank: "Rekening Bank",
			setting: "Pengaturan",
		},
		partner: {
			title: "Info Partner",
			name: "Nama Usaha",
			company: "Nama Perusahaan",
			address: "Alamat",
			phone: "Nomor Telepon",
			email: "Email",
			pic: "PIC",
			pic_phone: "Nomor Telepon PIC",
			commission: "Komisi (%)",
			referral_title: "Kode Referral Anda",
			referral_description:
				"Bagikan kode ini ke partner lain. Anda mendapat komisi",
		},
		bank: {
			title: "Rekening Bank",
			subtitle:
				"Rekening bank yang digunakan untuk menarik saldo Cazhbox partner Anda",
			notice:
				"Perhatian! Untuk penggantian data rekening bank silakan hubungi Admin melalui menu Bantuan.",
			bank: "Bank",
			holder: "Nama Rekening",
			number: "Nomor Rekening",
		},
		billing: {
			title: "Paket Aktif",
			current_package: "Paket",
			expired_at: "Berakhir pada",
			days_left: "Sisa hari",
			last_payment: "Pembayaran terakhir",
			expired_badge: "Kedaluwarsa",
			active_badge: "Aktif",
			extend_title: "Perpanjang Paket",
			extend_description: "Perpanjang paket yang sedang aktif.",
			change_title: "Ganti Paket",
			change_description: "Pindah ke paket lain mulai periode berikutnya.",
			qty: "Jumlah paket",
			choose_package: "Pilih paket",
			total: "Total",
			extend_action: "Perpanjang",
			change_action: "Ganti Paket",
			extend_success: "Paket berhasil diperpanjang",
			change_success: "Paket berhasil diubah",
			confirm_extend:
				"Yakin memperpanjang paket ini? Tagihan akan dibuat sesuai jumlah yang dipilih.",
			confirm_change:
				"Yakin mengganti paket? Tagihan akan dibuat sesuai paket dan jumlah yang dipilih.",
			no_packages: "Belum ada paket yang tersedia.",
			days_unit: "hari",
		},
		setting: {
			title: "Mata Uang",
			description: "Mata uang yang dipakai untuk menampilkan seluruh nominal.",
			search_placeholder: "Cari negara atau mata uang",
			current: "Mata uang aktif",
			save: "Simpan",
			success: "Mata uang berhasil diperbarui",
			empty: "Mata uang tidak ditemukan.",
		},
	},
};

export default accountId;
